import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiSummary = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 18,
	viewBox: "0 0 15 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0596 11.4286C10.0596 11.4286 6.85379 12.0649 6.03516 13.2284C5.08516 14.5789 5.02993 17.8171 5.0293 17.8563C5.02685 17.8156 4.82979 14.5785 3.87988 13.2284C3.26578 12.3557 1.39041 11.7793 0.491211 11.5458L0 11.4286C0 11.4286 3.06111 10.6633 3.87988 9.49988C4.83507 8.14231 5.02899 5.00481 5.0293 4.99988C5.0293 4.99988 5.22278 8.14124 6.17871 9.49988C6.99523 10.6603 10.0426 11.4246 10.0586 11.4286H10.0596Z",
			fill: "url(#paint0_linear_11750_370358)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0001 4.56543C14.962 4.57305 12.7205 5.02387 12.1436 5.84277C11.4667 6.80481 11.429 9.11662 11.4288 9.12988C11.4279 9.11486 11.289 6.80444 10.6124 5.84277C10.0325 5.01951 7.87156 4.56836 7.8575 4.56543H15.0001ZM11.4288 0C11.4288 0 11.5665 2.23041 12.2452 3.19531C12.8265 4.02154 15.0011 4.56445 15.0011 4.56445H7.8575C7.862 4.56333 10.0315 4.02062 10.6124 3.19531C11.2901 2.23215 11.4283 0.00759709 11.4288 0Z",
			fill: "#7C3BED"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_11750_370358",
			x1: 3.57176,
			y1: 8.92824,
			x2: 5.71433,
			y2: 12.8569,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#691DD3" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#A700FF"
			})]
		}) })
	]
});
export default SvgAiSummary;
